<template>
  <div
    class="globalOverlay360"
  >
    <button
      class="mz-button mz-button-close"
      :aria-label="$translate('Ceres::Template.closeIcon')"
      @click="toggle"
    >
      &#215;
    </button>
    <a
      v-if="isSupported"
      class="Magic360"
      data-options="filename: img{col}.jpg; columns:20; autospin-speed: 1800;"
    >
      <img
        :src="imagePath"
      >
    </a>
  </div>
</template>

<script>
export default {
    name: 'Image360Overlay',
    props: {
        imagePath: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            isSupported: false,
            loadScript: false
        }
    },
    watch: {
        isSupported () {
            if (this.isSupported) {
                setTimeout(() => {
                    const css = document.createElement('link')
                    css.rel = 'stylesheet'
                    css.href = 'https://cdn02.plentymarkets.com/lipqd1w763kt/frontend/shop_assets/js/360/magic360.css'
                    document.head.appendChild(css)
                    window.Magic360 = {}
                    const recaptchaScript = document.createElement('script')
                    recaptchaScript.setAttribute('src', 'https://cdn02.plentymarkets.com/lipqd1w763kt/frontend/shop_assets/js/360/magic360.js')
                    document.head.appendChild(recaptchaScript)
                }, 100)
            }
        }
    },
    methods: {
        toggle () {
            $('.globalOverlay360').toggleClass('active')
            $('body').toggleClass('menu-is-visible')
        },
        setSupported () {
            this.isSupported = true
        }
    }
}
</script>
